import React from 'react'
import { PermissionGroup, PermissionGroupContent } from '../components/permissionGroup'
import { ResellerSection, EngageToolPermissionsSection, GeneralPermissionsSection } from '../sections'
import { Permission, UserRole } from 'settings/schema'
import { FormikProps } from 'formik'
import { ResellerResponseItem } from 'settings/settingsService'
import { PermissionToggle } from '../components/permissionToggle'
import { useTranslation } from 'translations'

interface ControlPanelPermissionGroupProps {
    userRole: UserRole
    formik: FormikProps<any>
    resellerFieldDisabled: boolean
    resellersList: ResellerResponseItem[]
    loadingResellers: boolean
    isAdminGranted: boolean
    handlePermissionClick: (permission: Permission, granted: boolean) => void
}

export const ControlPanelPermissionGroup = ({
    userRole,
    formik,
    resellerFieldDisabled,
    resellersList,
    loadingResellers,
    isAdminGranted,
    handlePermissionClick,
}: ControlPanelPermissionGroupProps) => {
    const { t } = useTranslation()
    const controlPanelLoginDisabled = isAdminGranted || userRole === 'reseller'

    return (
        <PermissionGroup
            brandedTitle={t('settings.users.form.groups.controlPanel')}
            expanded={formik.values.permissions.control_panel_login}
            className="control-panel-permissions"
        >
            <div className="row">
                <PermissionToggle
                    permission="control_panel_login"
                    disabled={controlPanelLoginDisabled}
                    handleClick={handlePermissionClick}
                />
            </div>
            <PermissionGroupContent height={userRole === 'reseller' ? 76 : 206}>
                {userRole === 'reseller' ? (
                    <ResellerSection
                        resellerFieldDisabled={resellerFieldDisabled}
                        resellersList={resellersList}
                        loadingResellers={loadingResellers}
                        errorMessage={formik.errors.resellerId as string}
                    />
                ) : (
                    <>
                        <GeneralPermissionsSection
                            isAdminGranted={isAdminGranted}
                            handlePermissionClick={handlePermissionClick}
                        />
                        <EngageToolPermissionsSection
                            isAdminGranted={isAdminGranted}
                            handlePermissionClick={handlePermissionClick}
                        />
                    </>
                )}
            </PermissionGroupContent>
        </PermissionGroup>
    )
}
